import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SinSidebarLayout } from 'layouts/SinSidebarLayout';

export const TerminosYCondiciones = () => {
  const Section = ({ number, title, children, level = 1 }) => {
    // Mapeo de indentación por nivel
    const indentClass =
      {
        1: 'pl-0',
        2: 'pl-4',
        3: 'pl-8',
        4: 'pl-12'
      }[level] || 'pl-16'; // niveles mayores siguen aumentando

    return (
      <div className={`section level-${level} mb-4 ${indentClass}`}>
        {title ? (
          // Caso normal: número + título
          <Heading type={`h${level + 3}`}>
            {number} {title}
          </Heading>
        ) : (
          // Caso sin título: número con mismo diseño, seguido del texto
          <div className="flex items-start gap-2">
            <Heading type={`h${level + 3}`} className="flex items-center gap-2">
              <span className="font-bold">{number}</span>
            </Heading>
            <div className="flex-1">{children}</div>
          </div>
        )}

        {/* Renderizar children si hay título */}
        {title && <div className="pl-2">{children}</div>}
      </div>
    );
  };

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
        <Heading type="h2" className="text-center">
          TÉRMINOS Y CONDICIONES
        </Heading>
        <div className="bg-background-primary p-5 sm:p-10 rounded">
          <Text className="mb-6 font-semibold text-sm text-gray-600">
            Fecha de Última Actualización: 14 de diciembre de 2025
          </Text>

          <Section number="TÍTULO I:" title="DISPOSICIONES GENERALES"></Section>
          <Section
            number="1."
            title="Objeto y Alcance de Términos y Condiciones"
          >
            <Section number="1.1" title="Objeto" level={2}>
              <Text className="mb-4">
                Los presentes <strong>"Términos y Condiciones"</strong> (en
                adelante, <strong>"T&C"</strong>) regulan el acceso, registro y
                la utilización de la plataforma digital
                <strong> "Plataforma Industria Circular" </strong>
                (en adelante, <strong>"PIC"</strong> o{' '}
                <strong>"Plataforma"</strong>), operada por
                <strong> NEWEND SPA</strong>, RUT N°78.074.664-5 (en adelante,
                el <strong>"Operador"</strong> o la <strong>"Empresa"</strong>).
              </Text>
            </Section>
            <Section number="1.2" title="Alcance" level={2}>
              <Text className="mb-4">
                Estos <strong>"T&C"</strong> son de aplicación obligatoria para
                toda persona natural o jurídica que complete el proceso de
                registro y acceda a las funcionalidades de la misma. En lo
                sucesivo, y para todos los efectos del presente instrumento,
                dichas personas serán referidas simplemente como el{' '}
                <strong>"Usuario"</strong> o, en plural, los
                <strong>"Usuarios"</strong>.
              </Text>
            </Section>
            <Section number="1.3" title="Finalidad" level={2}>
              <Text className="mb-4">
                La <strong>"PIC"</strong> tiene por objeto principal fomentar la{' '}
                <strong>"Economía Circular"</strong> y la
                <strong>"Simbiosis Industrial"</strong>, implementando un medio
                de conexión entre sus distintos actores, a fin de (i) facilitar
                la conexión de oportunidades de negocio entre organizaciones
                para la reutilización y el reciclaje de materiales, residuos y
                subproductos no peligrosos; (ii) Servir como un directorio de
                empresas e iniciativas relacionadas con la industria circular; y
                (iii) Ofrecer información, recursos, indicadores y reportes
                asociados a la gestión de recursos y residuos.
              </Text>
            </Section>

            <Section number="1.4" title="Aceptación y Vinculación" level={2}>
              <Text className="mb-4">
                El acceso, registro, navegación y/o uso de cualquier
                funcionalidad de la <strong>"PIC"</strong> implica la plena,
                total e incondicional aceptación de estos <strong>"T&C"</strong>
                , de la <strong>"Política de Privacidad"</strong> y del
                <strong>
                  "Consentimiento para el Tratamiento de Datos Personales"
                </strong>
                , los cuales tienen carácter de contrato vinculante entre el{' '}
                <strong>"Usuario"</strong> y el <strong>"Operador"</strong>.
              </Text>
            </Section>
          </Section>

          <Section
            number="2."
            title="Naturaleza y Exclusión de Responsabilidad del Operador"
          >
            <Section number="2.1" title="Carácter de Intermediario" level={2}>
              <Text className="mb-4">
                La <strong>"Plataforma"</strong> actúa exclusivamente como un
                facilitador digital y punto de encuentro de contacto entre los{' '}
                <strong>"Usuarios"</strong>. La <strong>"PIC"</strong> no es
                parte, no interviene, ni se hace responsable de las
                negociaciones, acuerdos, transacciones o contratos comerciales
                que se realicen directamente entre los{' '}
                <strong>"Usuarios"</strong>.
              </Text>
            </Section>

            <Section
              number="2.2"
              title="Exclusión de Responsabilidad por Acuerdos"
              level={2}
            >
              <Text className="mb-4">
                El <strong>"Operador"</strong> no garantiza el éxito, la
                viabilidad, la calidad ni el cumplimiento de las propuestas de
                servicio ni de la ejecución de los servicios o transacciones
                pactados entre los <strong>"Usuarios"</strong>. El{' '}
                <strong>"Operador"</strong> se exime de toda responsabilidad
                derivada de la calidad, licitud o veracidad de los productos,
                materiales, servicios o información publicada por los{' '}
                <strong>"Usuarios"</strong>.
              </Text>
            </Section>

            <Section number="2.3" title="Verificación de Información" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> no tiene la obligación de
                verificar la exactitud de los datos de contacto, la capacidad
                legal o la solvencia de los
                <strong>"Usuarios"</strong>. Es responsabilidad exclusiva de
                cada <strong>"Usuario"</strong> realizar la debida diligencia
                sobre la contraparte antes de iniciar cualquier negociación o
                acuerdo comercial.
              </Text>
            </Section>
          </Section>
          <Section
            number="TÍTULO II:"
            title="OBLIGACIONES DE LOS USUARIOS"
          ></Section>
          <Section number="3." title="Condiciones de Uso y Registro">
            <Section number="3.1" title="Capacidad Legal" level={2}>
              <Text className="mb-4">
                El uso de la <strong>"Plataforma"</strong> está restringido a
                personas naturales legalmente capaces para contratar y a
                personas jurídicas válidamente constituidas, representadas por
                un apoderado con facultades suficientes.
              </Text>
            </Section>

            <Section number="3.2" title="Veracidad de la Información" level={2}>
              <Text className="mb-4">
                El <strong>"Usuario"</strong> se obliga a proporcionar
                información completa, veraz, exacta y actualizada, ya sea en el
                proceso de registro como y durante el uso de la{' '}
                <strong>"Plataforma"</strong>. La falta de veracidad en la
                información es causal de suspensión o eliminación de la cuenta,
                sin perjuicio de las acciones legales pertinentes.
              </Text>
            </Section>

            <Section number="3.3" title="Uso Lícito y Prohibiciones" level={2}>
              <Text className="mb-4">
                Queda estrictamente prohibido al <strong>"Usuario"</strong>:
                <br />
                a) Publicar material o información que sea ilegal, amenazante,
                difamatoria, obscena o que viole derechos de propiedad
                intelectual de terceros.
                <br />
                b) Utilizar la <strong>"Plataforma"</strong> para una finalidad
                distinta a la establecida en los presentes{' '}
                <strong>"T&C"</strong>.<br />
                c) Realizar acciones que puedan dañar, deshabilitar o
                sobrecargar los servidores o redes de la <strong>"PIC"</strong>.
                <br />
                d) Suplantar la identidad de otra persona o entidad.
              </Text>
            </Section>
          </Section>

          <Section
            number="4."
            title="Confidencialidad y Uso de Información de Terceros"
          >
            <Section number="4.1" title="Deber de Reserva Estricta" level={2}>
              <Text className="mb-4">
                El <strong>"Usuario"</strong> que acceda a información no
                pública de otros <strong>"Usuarios"</strong> a través de la
                <strong>"Plataforma"</strong> (incluyendo flujos de
                residuos/recursos, documentos técnicos, datos de contacto, entre
                otros) debe mantener estricta reserva sobre dicha información.
              </Text>
            </Section>

            <Section
              number="4.2"
              title="Uso Limitado y Prohibición de Cesión"
              level={2}
            >
              <Text className="mb-4">
                La información obtenida por los <strong>"Usuarios"</strong> a
                través de la <strong>"PIC"</strong> solo podrá ser utilizada con
                el fin específico de evaluar y concretar una propuesta de
                negocio o servicio dentro del marco de la{' '}
                <strong>"Plataforma"</strong>. Está estrictamente prohibido
                almacenar, procesar, ceder o divulgar la información de otros{' '}
                <strong>"Usuarios"</strong> a terceros, o utilizarla para fines
                comerciales o de marketing ajenos al objeto de la{' '}
                <strong>"PIC"</strong>, sin la autorización expresa y por
                escrito del <strong>"Usuario"</strong> involucrado.
              </Text>
            </Section>
          </Section>

          <Section
            number="5."
            title="Propiedad Intelectual y Contenido del Usuario"
          >
            <Section number="5.1" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> mantiene de parte del
                propietario, la licencia exclusiva sobre los logotipos,
                contenido, bases de datos y software de la{' '}
                <strong>"PIC"</strong>, los cuales están protegidos por las
                leyes de propiedad intelectual.
              </Text>
            </Section>

            <Section number="5.2" level={2}>
              <Text className="mb-4">
                El <strong>"Usuario"</strong> conserva la propiedad intelectual
                de los contenidos que publica (incluyendo ofertas, demandas,
                flujos de residuos, etc.), y otorga al{' '}
                <strong>"Operador"</strong> una licencia no exclusiva, gratuita
                y sublicenciable para utilizar, reproducir, modificar y
                distribuir dicho contenido dentro del contexto operativo,
                estadístico y de investigación de la
                <strong>"Plataforma"</strong>.
              </Text>
            </Section>

            <Section number="5.3" level={2}>
              <Text className="mb-4">
                Esta licencia incluye la facultad de usar la información del{' '}
                <strong>"Usuario"</strong>, de forma agregada y anonimizada, con
                fines de identificación de brechas, oportunidades de mejora del
                ecosistema y desarrollo de soluciones para ser puestas a
                disposición de los distintos actores del sector.
              </Text>
            </Section>

            <Section number="5.4" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> se reserva el derecho de retirar
                cualquier contenido que a su consideración infrinja estos
                <strong>"T&C"</strong> o los derechos de terceros.
              </Text>
            </Section>
          </Section>

          <Section
            number="TÍTULO III:"
            title="CIBERSEGURIDAD Y PROTECCIÓN DE SISTEMAS"
          ></Section>
          <Section number="6." title="Compromiso de Seguridad">
            <Section number="6.1" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> adoptará medidas de
                ciberseguridad técnicas y organizativas adecuadas para prevenir,
                contener y responder a incidentes de ciberseguridad, así como
                para proteger los datos personales.
              </Text>
            </Section>

            <Section number="6.2" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> podrá suspender el servicio
                temporalmente si existen riesgos de seguridad o ciberataques que
                comprometan la integridad de la <strong>"Plataforma"</strong> o
                la información de los <strong>"Usuarios"</strong>.
              </Text>
            </Section>
          </Section>

          <Section
            number="TÍTULO IV:"
            title="VIGENCIA Y JURISDICCIÓN"
          ></Section>
          <Section number="7." title="Modificaciones y Vigencia">
            <Section number="7.1" level={2}>
              <Text className="mb-4">
                El <strong>"Operador"</strong> se reserva el derecho de
                modificar unilateralmente estos <strong>"T&C"</strong> en
                cualquier momento. Toda modificación entrará en vigencia 30 días
                después de su publicación en la <strong>"Plataforma"</strong>.
                El uso continuado de la <strong>"Plataforma"</strong> después de
                dicho plazo implicará la aceptación de los nuevos términos.
              </Text>
            </Section>
          </Section>

          <Section number="8." title="Legislación Aplicable y Jurisdicción">
            <Section number="8.1" level={2}>
              <Text className="mb-4">
                Estos T&C se rigen por las leyes de la República de Chile.
              </Text>
            </Section>
            <Section number="8.2" level={2}>
              <Text className="mb-4">
                Cualquier controversia derivada de la aplicación,
                interpretación, cumplimiento o incumplimiento de estos T&amp;C
                será sometida a la jurisdicción de los tribunales ordinarios de
                justicia de la comuna de Santiago.
              </Text>
            </Section>
          </Section>
        </div>
      </div>
    </SinSidebarLayout>
  );
};
